export default __webpack_public_path__ + "static/media/fca0ec9dac892f57b3e917608d00ebdf1600888211408.1fbefda2.webp";